import { Loading as e } from "./index537.js";
import { buildProps as n, definePropType as a } from "./index601.js";
import { iconPropType as o } from "./index606.js";
import { useSizeProp as i } from "./index607.js";
const l = [
  "default",
  "primary",
  "success",
  "warning",
  "info",
  "danger",
  /**
   * @deprecated
   * Text type will be deprecated in the next major version (3.0.0)
   */
  "text",
  ""
], p = ["button", "submit", "reset"], f = n({
  /**
   * @description button size
   */
  size: i,
  /**
   * @description disable the button
   */
  disabled: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description button type
   */
  type: {
    type: String,
    values: l,
    default: ""
  },
  /**
   * @description icon component
   */
  icon: {
    type: o
  },
  /**
   * @description native button type
   */
  nativeType: {
    type: String,
    values: p,
    default: "button"
  },
  /**
   * @description determine whether it's loading
   */
  loading: Boolean,
  /**
   * @description customize loading icon component
   */
  loadingIcon: {
    type: o,
    default: () => e
  },
  /**
   * @description determine whether it's a plain button
   */
  plain: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description determine whether it's a text button
   */
  text: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description determine whether it's a link button
   */
  link: Boolean,
  /**
   * @description determine whether the text button background color is always on
   */
  bg: Boolean,
  /**
   * @description native button autofocus
   */
  autofocus: Boolean,
  /**
   * @description determine whether it's a round button
   */
  round: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description determine whether it's a circle button
   */
  circle: Boolean,
  /**
   * @description custom button color, automatically calculate `hover` and `active` color
   */
  color: String,
  /**
   * @description dark mode, which automatically converts `color` to dark mode colors
   */
  dark: Boolean,
  /**
   * @description automatically insert a space between two chinese characters
   */
  autoInsertSpace: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description custom element tag
   */
  tag: {
    type: a([String, Object]),
    default: "button"
  }
}), c = {
  click: (t) => t instanceof MouseEvent
};
export {
  c as buttonEmits,
  p as buttonNativeTypes,
  f as buttonProps,
  l as buttonTypes
};
